import { render, staticRenderFns } from "./SingleImage.vue?vue&type=template&id=bf4dbe64&scoped=true"
import script from "./SingleImage.vue?vue&type=script&lang=js"
export * from "./SingleImage.vue?vue&type=script&lang=js"
import style0 from "./SingleImage.vue?vue&type=style&index=0&id=bf4dbe64&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4dbe64",
  null
  
)

export default component.exports